export enum KEYS {
	TOWN_ID = 'townId',
	PLATFORM = 'platform',
	VERSION = 'version',
	SERVICE = 'service.v3',
	DEVICE_ID = 'deviceId'
}

export enum PLATFORMS {
	WEB = 'web',
	IOS = 'ios',
	ANDROID = 'android'
}

interface CommonPaymentOptions {
	failureUrl: string;
	displayType?: string;
	includeOrderId?: boolean;
	innerRedirect?: boolean;
	is_chocobalance_disabled?: boolean;
}

export interface IPaymentOptions extends CommonPaymentOptions {
	successUrl: string;
	authlessPayment?: boolean;
	backlink: string;
}

export interface PaymentParams extends CommonPaymentOptions {
	track_id: string;
	paymentUrl: string;
	environment: string;
	lang: string;
	sucessUrl: string;
}

export const isPlatforms = (value: string): value is PLATFORMS => {
	return (Object.values(PLATFORMS) as string[]).includes(value);
};
